/** @file Default crossfade seconds for a switch between two animations, from data.mixDefaults. */
import type { SkeletonData } from '../skeletonData';
import { baseName } from './baseName';

/**
 * mixDefaults["from>to"], where each side may name the animation or its @DIR base (validateDoc allows both), most
 * specific first (R4-01): a>b, a>base(b), base(a)>b, base(a)>base(b); else 0.
 */
export function mixDurationFor(data: SkeletonData, from: number, to: number): number {
  const a = data.animations[from]?.name;
  const b = data.animations[to]?.name;
  if (a === undefined || b === undefined) return 0;
  const mix = data.mixDefaults;
  const baseA = baseName(a);
  const baseB = baseName(b);
  return mix.get(`${a}>${b}`) ?? mix.get(`${a}>${baseB}`) ?? mix.get(`${baseA}>${b}`) ?? mix.get(`${baseA}>${baseB}`) ?? 0;
}
